import { render } from "./ActivePatients.vue?vue&type=template&id=56133774&scoped=true&lang=pug"
import script from "./ActivePatients.vue?vue&type=script&lang=js"
export * from "./ActivePatients.vue?vue&type=script&lang=js"

import "./ActivePatients.vue?vue&type=style&index=0&id=56133774&scoped=true&lang=scss"
import "./ActivePatients.vue?vue&type=style&index=1&id=56133774&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56133774"]])

export default __exports__